import 'containers/common/Detail.css';
import SLMEntityLinkList from "containers/slm/SLMEntityLinkList";
import React, { Component } from "react";
import { Modal } from "react-bootstrap";


export default class SLMEntityLinkModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
         
            isLoading: true,
            saleid: null, 
            leaseid: null,
            agencyname: null, 
            agencies: [],
            filter: {}, 
            isSearchAndSelect: true 
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
     
       
    }
    

    async componentDidMount() {
        console.log("In EntityLinkModal componentDidMount");
        if (!this.props.isAuthenticated) { // if false
            return;
        }

        if (!this.props.show) {
            return null;
        }

           
    }

    componentWillUnmount() {
        this.setState({ agencies: [] });
    }

    handleChange = event => {
        console.log("Inside handleChange");
        this.setState({
            [event.target.id]: event.target.value
        });

    }


    handleSubmit(event) {

        event.preventDefault();
        this.setState({ isLoading: true });
        console.log(this.state.filter);

              

        console.log(this.state.filter);


    }

    renderAgencies() {
        return (
            
            <Modal
                show={this.props.show}
                onHide={this.props.toggleSLMEntityLinkModal}
                dialogClassName="modal-90w"
                >
                <Modal.Header closeButton>
                    <Modal.Title>Agencies</Modal.Title>
                </Modal.Header>
                <Modal.Body>
           
                    
                                  

                        <SLMEntityLinkList
                            filter={this.props.filter}
                            isAuthenticated={this.props.isAuthenticated}
                            isLoading={this.state.isLoading}
                            controlType="table" 
                            saveForm={this.props.saveForm}
                            user={this.props.user}
                            data={this.props.data}
                            updateTableState={this.props.updateTableState}
                            saveRecord={this.props.saveRecord}
                            deleteRecord={this.props.deleteRecord}
                        />

                  
          
                    </Modal.Body>
            </Modal>
        );
    }
 


    render() {
        return (

            <div className="EntityLinkEdit">
                {this.props.isAuthenticated ? this.renderAgencies() : console.log("error)")}
            </div>
        );
    }
}
